module.exports = __webpack_public_path__ + "facb801c67e43de9b6515b4936bdb330.png";